import { Typography } from 'shared/ui'
import { Chip } from 'pages/settings/pages/integrations/pages/Webhooks/ui/Chip/Chip'
import styles from './styles.module.scss'

type IModalSelectedWebhookProps = {
  title: string
  lines: string[]
}

export const ModalSelectedWebhook = ({ title, lines }: IModalSelectedWebhookProps) => {
  return (
    <div className={styles.wrap}>
      <Typography
        ariaLabel='ModalInfoBlockWithTitle'
        variant='body-md-medium'
        color='var(--content-primary-tertiary)'
      >
        {title}
      </Typography>

      {lines.map((line) => (
        <Chip key={line} line={line} />
      ))}
    </div>
  )
}
